import { ADDITIONAL_LICENSE_ACTIVATION, LICENSE_ACTIVATION, VERIFY_EMAIL } from '@/router/auth.names';
import { LAYOUT_SIMPLE, LAYOUT_SPLIT } from './core.constants';
import { AUTH_JOIN_CLASS } from './me.names';

const hello = () => import('@/pages/hello.vue');
const betaLogin = () => import('@/pages/beta-login.vue');
const loginError = () => import('@/pages/login-error.vue');
const verifyEmail = () => import('@/pages/auth/verify-email.vue');
const initialJoinClass = () => import('@/pages/auth/initial-join-class.vue');
const activateLicense = () => import('@/pages/auth/activate-license.vue');
const additionalLicenseActivation = () => import('@/pages/additional-license-activation.vue');

export default [
  {
    path: '/hello',
    name: 'hello',
    component: hello,
    meta: {
      layout: 'split',
      public: true,
      illustration: 'hello',
      illustrationAlign: 'top',
      matomoUrl: '/auth/hello',
      title: 'Login',
    },
  },
  {
    path: '/beta-login',
    name: 'betaLogin',
    component: betaLogin,
    meta: {
      layout: 'public',
      public: true,
      matomoUrl: '/auth/beta-login',
    },
  },
  {
    path: '/auth/activate-license',
    component: activateLicense,
    name: LICENSE_ACTIVATION,
    meta: {
      public: true,
      layout: LAYOUT_SPLIT,
      matomoUrl: '/auth/activate-license',
    },
  },
  {
    path: '/auth/join-class',
    component: initialJoinClass,
    name: AUTH_JOIN_CLASS,
    meta: {
      public: true,
      layout: LAYOUT_SPLIT,
      matomoUrl: '/auth/join-class',
    },
  },
  {
    path: '/auth/verify-email',
    component: verifyEmail,
    name: VERIFY_EMAIL,
    meta: {
      public: true,
      layout: LAYOUT_SPLIT,
      matomoUrl: '/auth/verify-email',
    },
  },
  {
    path: '/unknown-auth-error',
    component: loginError,
    name: 'unknownAuthError',
    props: {
      title: 'Es ist ein Fehler aufgetreten',
      errorMessage:
        'Es tut uns leid, dass diese Seite im Moment nicht wie erwartet funktioniert. Bitte versuchen Sie es später nochmals.',
    },
    meta: {
      public: true,
      layout: 'public',
      matomoUrl: '/auth/unknown-auth-error',
    },
  },
  {
    path: '/additional-license-activation',
    component: additionalLicenseActivation,
    name: ADDITIONAL_LICENSE_ACTIVATION,
    matomoUrl: '/auth/additional-license-activation',
    meta: { layout: LAYOUT_SIMPLE, title: 'Coupon einlösen' },
  },
];
